import React, { FC } from "react";
import styles from "./AppDownloadSection.module.scss";
import { MailIcon, MessageCircle, PhoneIcon } from "@/components/icons";
import {
  Card,
  CardContent,
  Container,
  Divider,
  Typography,
} from "@mui/material";
import AppMockupSection from "../AppMockupSection/AppMockupSection";
import { useTranslations } from "next-intl";

interface AppDownloadSectionProps {}

const AppDownloadSection: FC<AppDownloadSectionProps> = () => {
  const contactInfo = [
    {
      icon: <PhoneIcon />,
      label: "Call us at:",
      value: "+966 920011188",
      hasSeparator: true,
    },
    {
      icon: <MailIcon />,
      label: "Or you can email us at:",
      value: "info@almuayed.com",
      hasSeparator: true,
    },
    {
      icon: <MessageCircle />,
      label: "Get support via WhatsApp:",
      value: "+966 502223840",
      hasSeparator: false,
    },
  ];
const t = useTranslations("");
  return (
    <section className="w-full flex flex-col items-center  max-c-lg:gap-8 bg-white">
      <AppMockupSection />

      <div className="w-full flex  justify-center py-6 bg-secondary">
        <div className="flex items-center justify-between c-lg:w-[80%] w-full max-w-[1312px] c-lg:flex-row flex-col max-c-lg:text-start max-c-lg:items-start max-c-lg:gap-2">
          {contactInfo.map((item, index) => (
            <React.Fragment key={index}>
              <div className="flex items-center py-2 px-4 c-lg:first:ps-0 gap-4 max-c-lg:min-w-[260px]">
                {item.icon}
                <div className="flex flex-col">
                  <Typography variant="body2" className="text-sm text-gray-800">
                    {t(item.label)}
                  </Typography>
                  <Typography variant="body1" className="text-lg font-semibold rtl:text-end" dir="ltr">
                    {item.value}
                  </Typography>
                </div>
              </div>

              {index < contactInfo.length - 1 && (
                <Divider
                  orientation="vertical"
                  className="h-12 mx-10 bg-[#d8dcde]"
                  flexItem
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;
